module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/132.020df1be.png";